let pieChart = {
  series: [44223, 55, 41, 17, 15],
  options: {
    chart: {
      width: 380,
      type: "donut",
    },
    plotOptions: {
      pie: {
        startAngle: -90,
        endAngle: 270,
      },
    },
    labels: ['Apple', 'Mango', 'Orange', 'Watermelon','Tes'],
    dataLabels: {
      enabled: true,
    },
    fill: {
      type: "gradient",
    },
    legend: {
      formatter: function (val, opts) {
        return val + " - " + opts.w.globals.series[opts.seriesIndex];
      },
    },
    title: {
      text: "Gradient Donut with custom Start-angle",
      style: {
        fontSize: '14px',
        fontWeight: 'bold',
        fontFamily: undefined,
        color:  '#000'
      },
    },
    subtitle: {
      text: "Gradient Donut with custom Start-angle",
      offsetX: 0,
      offsetY: 20,
      style: {
        fontSize: '12px',
        fontWeight: 'bold',
        fontFamily: undefined,
        color:  '#0900ff9e'
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  },
};

export default pieChart;